import styled from "styled-components"

export const EmptyStateStyled = styled.div`
  .empty-state-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    padding: 2rem;
  }

  .empty-state-content {
    text-align: center;
    max-width: 500px;
    padding: 2rem;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
  }

  .empty-state-icon {
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    
    svg {
      width: 80px;
      height: 80px;
      color: #9ca3af;
    }
  }

  .empty-state-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #374151;
    margin: 0 0 1rem 0;
    font-family: "Montserrat", sans-serif;
  }

  .empty-state-message {
    font-size: 1rem;
    color: #6b7280;
    line-height: 1.6;
    margin: 0 0 1.5rem 0;
    font-family: "Poppins", sans-serif;
  }

  .empty-state-action {
    margin-top: 1.5rem;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .empty-state-container {
      min-height: 300px;
      padding: 1rem;
    }

    .empty-state-content {
      padding: 1.5rem;
    }

    .empty-state-title {
      font-size: 1.25rem;
    }

    .empty-state-message {
      font-size: 0.9rem;
    }
  }
`
